import * as z from 'zod';

import { Expression } from '../../Expressions/AbstractExpressionEvaluator';

const UpdateLoanStatusToLiquidatedAction = z.object({
  type: z.literal('updateLoanStatusToLiquidated'),
  processedDate: Expression('plainDate'),
  soldPrice: Expression('number'),
});

const UpdateLoanStatusToREOAction = z.object({
  type: z.literal('updateLoanStatusToREO'),
  processedDate: Expression('plainDate'),
});

export type OnActivateAction = z.infer<typeof OnActivateAction>;
export const OnActivateAction = z.discriminatedUnion('type', [
  UpdateLoanStatusToLiquidatedAction,
  UpdateLoanStatusToREOAction,
]);

export type OnCompleteAction = z.infer<typeof OnCompleteAction>;
export const OnCompleteAction = z.discriminatedUnion('type', [
  UpdateLoanStatusToLiquidatedAction,
  UpdateLoanStatusToREOAction,
]);
